<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card class="pa-3">
        <v-img
          :height="$vuetify.breakpoint.smAndDown ? '100px' : '200px'"
          contain
          src="https://clinicaapps.blob.core.windows.net/static/images/assets/images/app_not_found.svg"
        ></v-img>
        <p class="headline font-weight-medium mt-3 text-center error--text">
          {{ $t("heading.expiredLink") }}
        </p>
        <v-card-text> {{ $t("error.expiredLink") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="green darken-1" text @click="dialog = false"
            >Agree</v-btn
          > -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: true
    };
  }
};
</script>